import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { LoadingService } from '../../services/loading.service';
import { EditDialogComponent } from '../editDialog/editDialogComponent';
import { EditDialogInstance } from '../editDialog/editDialogService';
import { CustomAttributeDefinition, CustomAttributeDefinitionInput, CustomAttributeSection } from '../../entities/customAttributes/customAttributes';
import { CustomAttributesService } from '../../services/customAttributes/customAttributesService';
import { RolesService } from '../../services/roles/roles.service';
import { EditSelectable } from '../../entities/formControls/edit-selectable';
import { ConnectedDeviceSettingsService } from '../../services/connectedDeviceSettings/connected-device-settings.service';
import { Observable, of, switchMap, take } from 'rxjs';
import { ConnectedDeviceSetting, ConnectedDeviceSettingInput } from '../../entities/connectedDeviceSetting/connectedDeviceSetting';
@Component({
  selector: 'app-versions-dialog',
  templateUrl: './app-versions-dialog.component.html',
  styleUrls: ['./app-versions-dialog.component.scss']
})
export class AppVersionsDialogComponent
  implements EditDialogInstance {

  appVersionsForm: FormGroup;

  connectedDeviceSettingsKeys: string[] = [
    'minAppVersion',
    'latestAppVersion',
    'minAppVersion_IOS',
    'latestAppVersion_IOS',
    'minAppVersion_ANDROID',
    'latestAppVersion_ANDROID'
  ];

  connectedDeviceSettings: ConnectedDeviceSetting[] = undefined;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    public loadingService: LoadingService,
    public connectedDeviceSettingsService: ConnectedDeviceSettingsService,
    private rolesService: RolesService
  ) {

    this.appVersionsForm = new FormGroup({});
    // Simple version format validator: matches X.Y.Z where X, Y, Z are numbers
    const versionFormatValidator = (control: import('@angular/forms').AbstractControl) => {
      const value = control.value;
      if (!value) return null;
      const versionRegex = /^\d+\.\d+\.\d+$/;
      return versionRegex.test(value) ? null : { invalidVersionFormat: true }; 
    };
    // add form controls with version format validator
    this.appVersionsForm.addControl('minAppVersion', new FormControl(undefined, [Validators.required, versionFormatValidator]));
    this.appVersionsForm.addControl('latestAppVersion', new FormControl(undefined, [Validators.required, versionFormatValidator]));

    this.appVersionsForm.addControl('minAppVersion_IOS', new FormControl(undefined, [versionFormatValidator]));
    this.appVersionsForm.addControl('latestAppVersion_IOS', new FormControl(undefined, [versionFormatValidator]));

    this.appVersionsForm.addControl('minAppVersion_ANDROID', new FormControl(undefined, [versionFormatValidator]));
    this.appVersionsForm.addControl('latestAppVersion_ANDROID', new FormControl(undefined, [versionFormatValidator]));

    // load values
    this.connectedDeviceSettingsService.getConnectedDeviceSettings(this.connectedDeviceSettingsKeys).pipe(
      take(1)
    ).subscribe(connectedDeviceSettings => {
      this.connectedDeviceSettings = connectedDeviceSettings;
      // convert the settings key value pair to an object so that we can patch the form
      const settingsObject = connectedDeviceSettings.reduce((acc, setting) => {
        acc[setting.key] = setting.value;
        return acc;
      }, {});
      this.appVersionsForm.patchValue(settingsObject);
    });

  }


  onConfirm(editDialogComponent: EditDialogComponent<any>): void {

    // the raw value returns the form values as an object
    // we need to convert those raw values into one ConnecteDeviceSettingInput object
    // and then into an array of ConnectedDeviceSettingInput
    // iterate over the raw form values and create an array of ConnectedDeviceSettingInput
    let formValues = this.appVersionsForm.getRawValue();

    const customAttributeDefinitionInputs: ConnectedDeviceSettingInput[] = Object.keys(formValues).map(key => {
      return new ConnectedDeviceSettingInput({
        key: key,
        value: formValues[key]
      });
    });

    if (customAttributeDefinitionInputs) {
      this.connectedDeviceSettingsService.updateConnectedDeviceSettings(customAttributeDefinitionInputs, (result: any) => {
        this.loadingService.setLoading(false);
        // reload page
        window.location.reload();
        this.ref.close(true);
      });
    } else {
        this.ref.close(false);
    }
  }

  onReject(editDialogComponent: EditDialogComponent<any>): void {
    this.ref.close(false);
  }

  getEditForm(): FormGroup {
    return this.appVersionsForm;
  }

}
